module.exports = __webpack_public_path__ + "static/img/title.de3aca6.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/media5/title.png
// module id = Z/lO
// module chunks = 7